import React, { Fragment } from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import {
	ToolbarButton, Toolbar, ToolbarButtonGroup,
	ToolbarInput, ToolbarMenu
} from 'neon-design-system';
import { ArticleSelectionKind, articleSelectionLabel } from '../../../shared/global-enums';
import { CATEGORIES_TREE } from '../../../gql/categories';
import { useQuery } from '@apollo/react-hooks';
import { ToolbarMenuItem, CategoryItemNode } from '../../../shared/types';
import { isString } from '../../../utils/get-type.utils';
import { categoriesToList } from '../../../utils/list-utils';
import { topicsOrCategories } from '../../../utils/utils';

const useStyles = makeStyles(theme => createStyles({
	headingCaption: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	search: {
		background: theme.palette.error.main
	},
	comboCategories: {
		maxWidth: 180
	}
}));

export interface ArticleFilterProps {
	searchString: string;
	articleKind: ArticleSelectionKind;
	onQueryStringChange: (value: string) => void;
	onSelectedKindChange: (value: ArticleSelectionKind) => void;
	onSelectedCategoryChange: (value: string) => void;
}

const ArticleFilter = (props: ArticleFilterProps) => {
	const classes = useStyles();

	const { loading, data } = useQuery(CATEGORIES_TREE, { fetchPolicy: 'network-only' });

	if (loading) return <></>;
	const treeData = (data?.categoriesAsTree as CategoryItemNode[]) ?? [];

	const categoryList = [{ title: `All ${topicsOrCategories(true)}`, value: '' },
		...categoriesToList<ToolbarMenuItem>(treeData, (cat) => {
			return {
				title: cat.name,
				value: cat._id,
				indentation: cat.level
			};
		})];

	return (
		<Fragment>
			<Toolbar
				id="article-toolbar"
				className={classes.headingCaption}>
				<ToolbarButtonGroup>
					{
						Object.values(ArticleSelectionKind).map((item, i: number) => {
							return <ToolbarButton key={i}
								text={articleSelectionLabel[item as ArticleSelectionKind]}
								selected={props.articleKind === item}
								onClick={() => props.onSelectedKindChange(item as ArticleSelectionKind)} />
						})}
				</ToolbarButtonGroup>
				<ToolbarButtonGroup>
					<ToolbarMenu
						id="article-toolbar-category-filter"
						openToTheLeft={false}
						value={categoryList[0].value}
						className={classes.comboCategories}
						onChange={value => isString(value) && props.onSelectedCategoryChange(value.toString())}
						items={categoryList} />
					<ToolbarInput
						id="article-toolbar-search"
						icon={'search'}
						placeholder="Search articles..."
						onChange={props.onQueryStringChange} />
				</ToolbarButtonGroup>
			</Toolbar>
		</Fragment>
	);
};

export default ArticleFilter;
